<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="text-center fw-bold w-100 mt-2">{{ currentPageContent() | translateToken: "title" }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body overflow-x-hidden p-3">
        <div class="row">
            <div
                class="col-xs-12"
                [class.col-sm-8]="currentPageContent()?.imageIdEN || currentPageContent()?.imageIdAE"
                [class.col-sm-12]="!currentPageContent()?.imageIdEN && !currentPageContent()?.imageIdAE"
            >
                <div [innerHTML]="currentPageContent() | translateToken: 'helpContent'"></div>
            </div>
            @if (currentPageContent()?.imageIdEN || currentPageContent()?.imageIdAE) {
                <div class="col-sm-4 col-xs-12 d-flex justify-content-center align-items-center">
                    <adaa-picture
                        [width]="'200px'"
                        [pictureId]="
                            AdaaHelper.getCurrentLang() === Language.English ? currentPageContent()?.imageIdEN : currentPageContent()?.imageIdAE
                        "
                    />
                </div>
            }
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-end mt-3">
        @if (contents().length > 1) {
            <div class="my-2 d-flex gap-3">
                <button class="btn btn-outline-primary" (click)="changePage('prev')" [disabled]="currentPage === 0">
                    <i
                        [class.adaa-icon-arrow_back_ios]="AdaaHelper.getCurrentLang() === Language.English"
                        [class.adaa-icon-arrow_forward_ios]="AdaaHelper.getCurrentLang() === Language.Arabic"
                    ></i>
                </button>
                <button class="btn btn-outline-primary" (click)="changePage('next')" [disabled]="currentPage === contents().length - 1">
                    <i
                        [class.adaa-icon-arrow_back_ios]="AdaaHelper.getCurrentLang() === Language.Arabic"
                        [class.adaa-icon-arrow_forward_ios]="AdaaHelper.getCurrentLang() === Language.English"
                    ></i>
                </button>
            </div>
        }
    </div>
</ng-template>
